<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { availableLocales, setLocale } from '@/plugins/i18n'
const { locale } = useI18n()
</script>

<template>
  <v-menu min-width="150">
    <template #activator="{ props }">
      <v-btn v-bind="props" variant="plain" icon="mdi-translate" />
    </template>
    <v-list class="w-full pa-0" density="compact">
      <v-list-item
        v-for="loc in availableLocales"
        @click="() => setLocale(loc.code)"
        :active="loc.code === locale"
        :key="loc.code"
        :title="loc.name"
      />
    </v-list>
  </v-menu>
</template>

<style scoped lang="scss"></style>
